import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-48318881"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-item-container mb-6" }
const _hoisted_2 = { class: "fixed-content-container" }
const _hoisted_3 = { class: "header pb-2" }
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = { class: "font-weight-black" }
const _hoisted_6 = { class: "header-tool-icons" }
const _hoisted_7 = {
  ref: "collapsableContentContainer",
  class: "collapsable-content-container"
}
const _hoisted_8 = { style: {"overflow":"hidden"} }
const _hoisted_9 = { class: "body pb-1" }
const _hoisted_10 = { class: "font-weight-black" }
const _hoisted_11 = {
  key: 0,
  class: "body pb-1"
}
const _hoisted_12 = { class: "font-weight-black" }
const _hoisted_13 = { class: "form-refs-container" }
const _hoisted_14 = { class: "font-weight-black pb-2" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_icon, {
              class: "item-icon cursor-move",
              icon: "mdi-drag-vertical",
              size: "large"
            }),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('i18n.navigationItemTitle')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_btn, {
              class: "cursor-pointer",
              variant: "text",
              icon: "",
              onClick: _ctx.duplicateItem,
              disabled: !_ctx.userCanEditFormItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { icon: "$gorateDuplicate" }),
                _createVNode(_component_v_tooltip, {
                  activator: "parent",
                  location: "start"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.duplicate')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_v_btn, {
              class: "cursor-pointer",
              variant: "text",
              icon: "",
              onClick: _ctx.removeItem,
              disabled: !_ctx.userCanEditFormItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "small",
                  icon: "$gorateDeleteOutline"
                }),
                _createVNode(_component_v_tooltip, {
                  activator: "parent",
                  location: "start"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.remove')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_v_btn, {
              class: "cursor-pointer",
              variant: "text",
              icon: "",
              onClick: _ctx.expandGrid,
              disabled: !_ctx.userCanEditFormItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: _ctx.expandGridButtonIconName,
                  size: "large"
                }, null, 8, ["icon"]),
                _createVNode(_component_v_tooltip, {
                  activator: "parent",
                  location: "start"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.collapse')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('i18n.language1')), 1),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.itemData.question_lang1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemData.question_lang1) = $event)),
              density: "compact",
              placeholder: _ctx.$t('i18n.questionLang1'),
              variant: "outlined",
              dense: "",
              "hide-details": "auto",
              clearable: "",
              rules: _ctx.questionRules,
              counter: "",
              disabled: !_ctx.userCanEditFormItems
            }, null, 8, ["modelValue", "placeholder", "rules", "disabled"]),
            (!_ctx.userCanEditFormItems)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  activator: "parent",
                  location: "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.editNotAvailable')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.bilingual)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('i18n.language2')), 1),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.itemData.question_lang2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemData.question_lang2) = $event)),
                  density: "compact",
                  placeholder: _ctx.$t('i18n.questionLang2'),
                  variant: "outlined",
                  dense: "",
                  "hide-details": "auto",
                  clearable: "",
                  rules: _ctx.questionRules,
                  counter: ""
                }, null, 8, ["modelValue", "placeholder", "rules"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createTextVNode(_toDisplayString(_ctx.$t('i18n.referencesToForms')) + " ", 1),
                  (_ctx.itemData.form_item_options)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "(" + _toDisplayString(_ctx.itemData.form_item_options.length) + ")", 1))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemData.form_item_options, (option, index) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "pb-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "pb-0" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Título ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { class: "pt-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "pt-0" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: option.text_lang1,
                                "onUpdate:modelValue": ($event: any) => ((option.text_lang1) = $event),
                                counter: "",
                                placeholder: _ctx.$t('i18n.navigationPlaceholderLang1', { index: index + 1 }),
                                required: "",
                                density: "compact",
                                variant: "outlined",
                                dense: "",
                                "hide-details": "auto",
                                clearable: "",
                                rules: _ctx.optionRules,
                                disabled: !_ctx.userCanEditFormItems
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "rules", "disabled"]),
                              (!_ctx.userCanEditFormItems)
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    activator: "parent",
                                    location: "center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('i18n.editNotAvailable')), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", null, _toDisplayString(_ctx.$t('i18n.associatedForm')), 1),
                              _createVNode(_component_v_select, {
                                modelValue: option.referenced_form_id,
                                "onUpdate:modelValue": ($event: any) => ((option.referenced_form_id) = $event),
                                items: _ctx.formList,
                                placeholder: _ctx.$t('i18n.formListPlaceholder'),
                                variant: "outlined",
                                density: "compact",
                                required: "",
                                "item-title": "name",
                                "item-value": "id",
                                disabled: !_ctx.userCanEditFormItems,
                                rules: _ctx.referencedFormRules,
                                "no-data-text": _ctx.$t('i18n.noForms')
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "placeholder", "disabled", "rules", "no-data-text"])
                            ]),
                            _: 2
                          }, 1024),
                          (_ctx.bilingual)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                class: "pt-0"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_16,
                                  _createVNode(_component_v_text_field, {
                                    modelValue: option.text_lang2,
                                    "onUpdate:modelValue": ($event: any) => ((option.text_lang2) = $event),
                                    counter: "",
                                    placeholder: _ctx.$t('i18n.navigationPlaceholderLang2', { index: index + 1 }),
                                    required: "",
                                    density: "compact",
                                    variant: "outlined",
                                    dense: "",
                                    "hide-details": "auto",
                                    clearable: "",
                                    rules: _ctx.optionRules
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "rules"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_col, {
                            cols: "auto",
                            class: "pt-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                variant: "flat",
                                icon: "",
                                onClick: ($event: any) => (_ctx.removeFormReference(index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    icon: "$gorateDeleteOutline",
                                    disabled: !_ctx.userCanEditFormItems
                                  }, null, 8, ["disabled"]),
                                  _createVNode(_component_v_tooltip, {
                                    activator: "parent",
                                    location: "start"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('i18n.remove')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "auto",
                            class: "pt-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                variant: "text",
                                icon: "",
                                onClick: ($event: any) => (_ctx.moveUp(index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "x-small",
                                    icon: "mdi-arrow-up"
                                  }),
                                  _createVNode(_component_v_tooltip, {
                                    activator: "parent",
                                    location: "start"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('i18n.moveUp')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_v_btn, {
                                variant: "text",
                                icon: "",
                                onClick: ($event: any) => (_ctx.moveDown(index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "x-small",
                                    icon: "mdi-arrow-down"
                                  }),
                                  _createVNode(_component_v_tooltip, {
                                    activator: "parent",
                                    location: "start"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('i18n.moveDown')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      (_ctx.itemData.form_item_options && index < _ctx.itemData.form_item_options.length - 1)
                        ? (_openBlock(), _createBlock(_component_v_divider, {
                            key: 0,
                            thickness: 4
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_btn, {
            variant: "outlined",
            onClick: _ctx.addFormReference,
            disabled: !_ctx.userCanEditFormItems
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('i18n.addFormReference')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          (_ctx.optionCountErrorMessage)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 1,
                class: "mt-3 mb-3",
                variant: "outlined",
                type: "warning",
                dense: "",
                closable: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.optionCountErrorMessage), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ], 512)
    ]),
    _createVNode(_component_v_divider, {
      thickness: 2,
      class: "border-opacity-100 mb-3",
      color: "grey"
    })
  ], 64))
}